interface PlanLike {
  value?: unknown;
  value_usd?: unknown;
  [key: string]: unknown;
}

/** The cheapest PAID monthly price across plans, in the viewer's currency
 *  column — the number the upgrade dialogs anchor on ("a partir de R$X/mês").
 *  Free plans and malformed values are skipped; null when nothing is paid. */
export function findCheapestPaidPlanPrice(
  plans: PlanLike[] | null | undefined,
  isBRL: boolean,
): number | null {
  if (!Array.isArray(plans)) return null;
  let cheapest: number | null = null;
  for (const plan of plans) {
    const raw = isBRL ? plan?.value : plan?.value_usd;
    const value = Number(raw);
    if (!Number.isFinite(value) || value <= 0) continue;
    if (cheapest === null || value < cheapest) cheapest = value;
  }
  return cheapest;
}
